import { PendingInvoicesApiResponse } from '../../app/core/domain/interfaces/pending-invoices/pending-invoices.interface';

export const MOCK_PENDING_INVOICES: PendingInvoicesApiResponse = {
  accountName: 'Dadiana Ramírez',
  statusCode: 200,
  policies: [
    {
      policy: '1000006385',
      plan: 'Plan Esencial',
      product: 'Autos',
      paymentSchedules: [
        {
          paymentScheduleId: 'sch-001',
          totalAmount: 150000,
          paymentDueDate: '2025-05-25',
          documentNumber: '1000000014005',
          policy: '1000006385',
          frequency: 'Monthly',
        },
        {
          paymentScheduleId: 'sch-002',
          totalAmount: 150000,
          paymentDueDate: '2025-06-25',
          documentNumber: '1000000014006',
          policy: '1000006385',
          frequency: 'Monthly',
        },
      ],
    },
    {
      policy: '1000006432',
      plan: 'Plan Total',
      product: 'Autos',
      paymentSchedules: [
        {
          paymentScheduleId: 'sch-003',
          totalAmount: 281699,
          paymentDueDate: '2025-04-28',
          documentNumber: '1000000071979',
          policy: '1000006432',
          frequency: 'Annual',
        },
      ],
    },
  ],
};

export const MOCK_PENDING_INVOICES_EMPTY: PendingInvoicesApiResponse = {
  accountName: 'Dadiana Ramírez',
  statusCode: 200,
  policies: [],
};
